import Layout from '@/layout'

const IntegratedRouter = {
  path: '/Integrated',
  component: Layout,
  redirect: 'noredirect',
  name: 'Integrated',
  meta: {
    title: 'integrated',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'IEBooking',
      component: () => import('@/views/cargo/v0/Integrated/ieBooking'),
      name: 'IEBooking',
      meta: { title: 'iEBooking' },
      roles: ['module_IEBooking']
    },
    {
      path: 'TTIEVerify',
      component: () => import('@/views/cargo/v0/Integrated/TTIEVerify'),
      name: 'TTIEVerify',
      meta: { title: 'TTIEVerify' },
      roles: ['module_TTIEVerify']
    },
    {
      path: 'CLIEVerify',
      component: () => import('@/views/cargo/v0/Integrated/CLIEVerify'),
      name: 'CLIEVerify',
      meta: { title: 'CLIEVerify' },
      roles: ['module_CLIEVerify']
    },
    {
      path: 'ICIEVerify',
      component: () => import('@/views/cargo/v0/Integrated/ICIEVerify'),
      name: 'ICIEVerify',
      meta: { title: 'ICIEVerify' },
      roles: ['module_ICIEVerify']
    },
    {
      path: 'TTIEBooking',
      component: () => import('@/views/cargo/v0/Integrated/TTieBooking'),
      name: 'TTIEBooking',
      meta: { title: 'TTIEBooking' },
      roles: ['module_TTIEBooking']
    },
    {
      path: 'CLIEBooking',
      component: () => import('@/views/cargo/v0/Integrated/CLieBooking'),
      name: 'CLIEBooking',
      meta: { title: 'CLIEBooking' },
      roles: ['module_CLIEBooking']
    },
    {
      path: 'ICIEBooking',
      component: () => import('@/views/cargo/v0/Integrated/ICieBooking'),
      name: 'ICIEBooking',
      meta: { title: 'ICIEBooking' },
      roles: ['module_ICIEBooking']
    },
    {
      path: 'IEBatchUploadFile',
      component: () => import('@/views/cargo/v0/Integrated/uploadFile/index'),
      name: 'IEBatchUploadFile',
      meta: { title: '上传文件' },
      roles: ['module_BatchUploadFile']
    },
    {
      path: 'ImportCharge',
      component: () => import('@/views/cargo/v0/Integrated/ImportCharge/index'),
      name: 'ImportCharge',
      meta: { title: '批量导入费用(综合物流)' },
      roles: ['module_fmImportChargeIE']
    }
  ]
}

export default IntegratedRouter
